import { PLAYER_STATUSES } from '@/constants/tournaments';

export const playerStatuses = {
  computed: {
    localizedPlayerStatuses() {
      let statuses = PLAYER_STATUSES.reduce((res, obj) => {
        res[obj.name] = this.$t(obj.key, obj.label);
        return res;
      }, {});
      return statuses;
    },
  },
};
